module.exports = __webpack_public_path__ + "static/media/icon-facebook-login.a7e34e97.svg";